import { Type } from "../types";

/**
 * Returns a more human readable field type.
 */

export default function fieldTypeAsString(type: Type) {
  switch (type) {
    case "text":
      return "Text";
    case "numeric":
      return "Numeric";
    case "textarea":
      return "Text Area";
    case "textpredefinedoptions":
      return "Predefined Options";
    case "textunit":
      return "Text with Unit";
    case "numericunit":
      return "Numeric with Unit";
    case "date":
      return "Date";
    case "daterange":
      return "Date Range";
    case "datetimerange":
      return "Date & Time Range";
    case "datetime":
      return "Date & Time";
    case "time":
      return "Time";
    case "timerange":
      return "Time Range";
    case "country":
      return "Country";
    case "contacts":
      return "Contact";
    case "users":
      return "User";
    case "teams":
      return "Team";
    case "activitylink":
      return "Activity Link";
    case "linkedfrom":
      return "Linked Activities";
    case "subheader":
      return "Subheader";
    default:
      return "Unknown Field Type";
  }
}
